import Vue from 'vue';
import Vuex from 'vuex';
import actions from './forms-actions';
import getters from './forms-getters';
import mutations from './forms-mutations';
import state from './forms-state';

Vue.use(Vuex);
export default {
  namespaced: true,
  actions,
  getters,
  mutations,
  state,
};
